function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "i-360video",
  transform: "translate(0 -2.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1466",
  "data-name": "Path 1466",
  d: "M12.65,293.673a1.28,1.28,0,1,0-2.177,1.346l1.422,2.321a21.1,21.1,0,0,1-6.5-2.713c-1.3-.874-2.84-2.276-2.84-3.988a3.589,3.589,0,0,1,.809-2.134,6.4,6.4,0,0,1-.724-2.958A6.86,6.86,0,0,0,0,290.639c0,2.25,1.373,4.367,3.971,6.119a23.674,23.674,0,0,0,7.311,3.073l-2.5,1.288a1.285,1.285,0,0,0,.584,2.427,1.267,1.267,0,0,0,.582-.142l5.357-2.759a1.287,1.287,0,0,0,.505-1.816Zm0,0",
  transform: "translate(0 -261.047)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1467",
  "data-name": "Path 1467",
  d: "M282.62,285.559a6.065,6.065,0,0,1-.72,2.864,3.42,3.42,0,0,1,.805,2.065c0,1.684-1.673,3.45-4.59,4.845a33.573,33.573,0,0,1-12.651,2.741,1.243,1.243,0,1,0,.054,2.485h.056a36.17,36.17,0,0,0,13.659-2.992c3.879-1.855,6.015-4.369,6.015-7.078a6.587,6.587,0,0,0-2.628-4.929Zm0,0",
  transform: "translate(-242.247 -261.058)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1468",
  "data-name": "Path 1468",
  d: "M243,139.59v6l4-3Zm0,0",
  transform: "translate(-223 -126.09)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1469",
  "data-name": "Path 1469",
  d: "M64.808,28.5H90.192A3.817,3.817,0,0,0,94,24.682V4.318A3.817,3.817,0,0,0,90.192.5H64.808A3.817,3.817,0,0,0,61,4.318V24.682A3.817,3.817,0,0,0,64.808,28.5ZM89.346,5.556h.846a1.273,1.273,0,0,1,0,2.545h-.846a1.273,1.273,0,0,1,0-2.545Zm0,5.091h.846a1.273,1.273,0,0,1,0,2.545h-.846a1.273,1.273,0,0,1,0-2.545Zm0,5.091h.846a1.273,1.273,0,0,1,0,2.545h-.846a1.273,1.273,0,0,1,0-2.545Zm0,5.091h.846a1.273,1.273,0,0,1,0,2.545h-.846a1.273,1.273,0,0,1,0-2.545ZM73.862,9.756a1.269,1.269,0,0,1,2.031-1.018l6.262,4.709a1.275,1.275,0,0,1,0,2.036l-6.262,4.709a1.269,1.269,0,0,1-2.031-1.018ZM64.816,5.564h.846a1.273,1.273,0,0,1,0,2.545h-.846a1.273,1.273,0,0,1,0-2.545Zm0,5.091h.846a1.273,1.273,0,0,1,0,2.545h-.846a1.273,1.273,0,0,1,0-2.545Zm0,5.091h.846a1.273,1.273,0,0,1,0,2.545h-.846a1.273,1.273,0,0,1,0-2.545Zm0,5.091h.846a1.273,1.273,0,0,1,0,2.545h-.846a1.273,1.273,0,0,1,0-2.545Zm0,0",
  transform: "translate(-56 2)"
}));

var SvgI360Video = function SvgI360Video(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgI360Video, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/i-360video.1ae779f8.svg";
export { ForwardRef as ReactComponent };